import { createSelector } from 'reselect';
import { IApplicationState } from 'src/~store/models/ApplicationState';

const analyticsStateSelector = (state: IApplicationState) => state.analyticsState;
const channelsStateSelector = (state: IApplicationState) => state.channelState;

const analyticsSelector = createSelector(
    analyticsStateSelector,
    analyticsState => analyticsState.analytics,
);

const channelsSelector = createSelector(
    channelsStateSelector,
    channelsState => channelsState.channelList
);

const dialogStatsSelector = createSelector(
    analyticsSelector,
    analytics => analytics.dialogStats 
);

const chartsSelector = createSelector(
    analyticsSelector,
    analytics => analytics.charts
);

export const selectedTabSelector = createSelector(
    analyticsSelector,
    analytics => analytics.selectedTab
);

export const channelsListSelector = createSelector(
    channelsSelector,
    channels => channels.channels
)

export const analyticsTagsSelector = createSelector(
    analyticsSelector,
    analytics => analytics.tags
)

export const selectedSubtabSelector = createSelector(
    analyticsSelector,
    analytics => analytics.selectedSubtab
);

export const selectedCurrentSettingsSelector = createSelector(
    analyticsSelector,
    analytics => analytics.currentSettings
);

export const selectedTabKeysSelector = createSelector(
    analyticsSelector,
    analytics => analytics.allKeys
);

export const reportsAllKeysSelector = createSelector(
    analyticsSelector,
    analytics => analytics.reports.allKeys
);

export const reportsSelectedSubtabSelector = createSelector(
    analyticsSelector,
    analytics => analytics.reports.selectedSubtab
);

export const selectedReportsCurrentSettingsSelector = createSelector(
    analyticsSelector,
    analytics => analytics.reports.currentSettings
);

export const reportSelector = createSelector(
    analyticsSelector,
    analytics => {
        const data: { keys: string[], data: any[]} = {
            keys: [],
            data: [],
        }
        if(analytics.reports.report?.length > 0 && typeof analytics.reports.report === 'object') {
            data.keys = Object.keys(analytics.reports.report[0]);
            data.data = analytics.reports.report;
        }
        return data;
    }
);

export const isReportLoad = createSelector(
    analyticsSelector,
    analytics => analytics.reports.isLoad
)

export const menuDialogStatsSelector = createSelector(
    dialogStatsSelector,
    dialogStats => dialogStats.menuDialogStats
);

export const botsSelector = createSelector(
    dialogStatsSelector,
    dialogStats => dialogStats.bots
);

export const selectedBotIdSelector = createSelector(
    dialogStatsSelector,
    dialogStats => dialogStats.selectedBotId
);

export const allChartsSelector = createSelector(
    chartsSelector,
    charts => charts.allCharts
);